import {
  BaseText,
  EBaseTextPosition,
  EBaseTextSize,
  EBaseTextWeight,
} from '@spinwise/react-component-library/BaseText';
import React, { useEffect, useState } from 'react';
import styles from './ThumbnailElement.module.scss';
import Link from 'Components/shared/Link/Link';
import { useDispatch, useSelector } from 'react-redux';
import {
  IApplicationState,
  OVERLAY_GAME_POPUP_SHOW,
  OVERLAY_LOGIN_SHOW,
  OVERLAY_PAYNPLAY_LOGIN_SHOW,
  OVERLAY_PROMOTION_SHOW,
} from '@spinwise/spinwise-core';
import { IconLibrary } from 'Libraries/icons.library';
import { EBrandIconVariants, IconVariantsLibrary } from 'Libraries/variants.library';
import { t } from 'i18next';
import { EBrandTextColor } from 'Libraries/typography.library';
import { useRegType } from 'Hooks/useRegType';
import router from 'next/router';
import useGameLockCheck from 'Hooks/useGameLockCheck';
import { BaseIcon } from '@spinwise/react-component-library/BaseIcon';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';
import { RegTypes } from 'Types/globals';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

export interface IThumbnailElementProps {
  imgUrl?: string;
  name?: string;
  demoLink?: string;
  hasDemo?: number;
  widthItem?: number;
  urlKey?: string;
  isFavorite?: boolean;
  eid?: string;
  category?: string[];
  provider?: string;
  allowBonus?: boolean;
  minBet?: any;
  maxBet?: any;
}

const ThumbnailElement = (props: IThumbnailElementProps) => {
  const { auth } = useSelector((store: IApplicationState) => store.authReducer);
  const { info } = useSelector((store: IApplicationState) => store.accountReducer);

  const [imgIsLoaded, setImgIsLoaded] = useState(true);
  const [isFavorite, setIsFavorite] = useState(false);
  const dispatch = useDispatch();
  const isRegType = useRegType();
  const isClassic = isRegType([RegTypes.EMAIL, RegTypes.DEPOSIT]);
  const demoUrl = `/demo/${props.urlKey}`;
  const playUrl = `/play/${props.urlKey}`;

  const showLoginButton = useShowAuthButtons();

  const isGameLockedByBonus = useGameLockCheck()(props.allowBonus);

  const isLiveGame = props.category?.includes('Live Casino');
  const hasDemo = !isLiveGame && props?.hasDemo == 1;

  const openSignInPopup = () => {
    toggleGamePopup(false);

    dispatch({
      type: isClassic ? OVERLAY_LOGIN_SHOW : OVERLAY_PAYNPLAY_LOGIN_SHOW,
      data: true,
    });
  };

  const openDesiredPopup = () => {
    if (
      info?.activeBonus?.data?.max_bet_forced == 'yes' &&
      !info?.isMaxbetPopupShown &&
      !localStorage?.getItem('maxBetsLimitedPopUp')
    ) {
      toggleGamePopup(true, true);
    } else if (info?.isMaxbetPopupShown && info?.activeBonus?.data?.max_bet_forced == 'yes') {
      localStorage?.removeItem('maxBetsLimitedPopUp');
      toggleGamePopup(true);
    } else {
      toggleGamePopup(true);
    }
  };

  const handleClick = () => {
    info?.isMonetaryActivityEnabled ? null : () => openDesiredPopup();

    if (
      info?.activeBonus?.data?.max_bet_forced == 'yes' &&
      !info?.isMaxbetPopupShown &&
      !localStorage?.getItem('maxBetsLimitedPopUp')
    ) {
      toggleGamePopup(true, true);
    } else {
      if (localStorage?.getItem('maxBetsLimitedPopUp')) {
        localStorage?.removeItem('maxBetsLimitedPopUp');
      }

      router.push(playUrl);
    }
  };

  const toggleGamePopup = (open: boolean, maxBetsLimited?: boolean) => {
    dispatch({
      type: OVERLAY_PROMOTION_SHOW,
      content: { show: false },
    });

    dispatch({
      type: OVERLAY_GAME_POPUP_SHOW,
      data: {
        show: open,
        data: open
          ? {
              ...props,
              isGameLockedByBonus,
              isMonetaryActivityEnabled: info?.isMonetaryActivityEnabled,
              isLiveGame: !hasDemo,
              isFavorite,
              loggedIn: auth?.success,
              maxBetsLimited: maxBetsLimited,
            }
          : {},
      },
    });
  };
  useEffect(() => {
    setIsFavorite(props.isFavorite);
  }, [props.isFavorite]);

  const CustomLink = info?.isMonetaryActivityEnabled ? Link : 'div';

  return (
    <>
      <div
        className={`pos-r d-fl jc-c ${isGameLockedByBonus ? '' : 'ai-c'} ${styles.thumbnail_item_main}`}
        style={{
          width: `${props.widthItem}px`,
          height: `${props.widthItem * 1.345}px`,
        }}
      >
        {isGameLockedByBonus && (
          <div className={`pos-a d-fl ai-c ${styles.lockedByBonus}`}>
            <BaseIcon
              iconName={IconLibrary.LockSmall}
              variant={EBrandIconVariants.Purple}
              isMasked={true}
              isActive={false}
            />
            <BaseText
              alignment={EBaseTextPosition.Center}
              value={t('locked.game.by.bonus')}
              color={EBrandTextColor.Purple}
              size={EBaseTextSize.MicroLabels}
              weight={EBaseTextWeight.W600}
            />
          </div>
        )}
        {isLiveGame && (
          <div className={`pos-a pos-a-b ${styles.betTitle}`}>
            {props.minBet && props.maxBet && (
              <>
                <BaseText
                  value={`${t('thumbnail.bet.text.short')} `}
                  size={EBaseTextSize.Small}
                  weight={EBaseTextWeight.W400}
                  color={EBrandTextColor.White06}
                />
                <BaseText
                  value={props.minBet}
                  size={EBaseTextSize.Small}
                  weight={EBaseTextWeight.W400}
                  color={EBrandTextColor.White06}
                />
                <BaseText
                  value={' - '}
                  size={EBaseTextSize.Small}
                  weight={EBaseTextWeight.W400}
                  color={EBrandTextColor.White06}
                />
                <BaseText
                  value={props.maxBet}
                  size={EBaseTextSize.Small}
                  weight={EBaseTextWeight.W400}
                  color={EBrandTextColor.White06}
                />
              </>
            )}
            {(!props.minBet || !props.maxBet) && (
              <BaseText
                value={t('thumbnail.bet.text')}
                size={EBaseTextSize.Small}
                weight={EBaseTextWeight.W400}
                color={EBrandTextColor.White06}
              />
            )}
          </div>
        )}
        {imgIsLoaded && <img className={styles.zoom_img} src={`${props.imgUrl}`} alt="" />}
        {!imgIsLoaded && <div className={`${styles.zoom_img} ${styles.load_image} `}></div>}
        <div
          className={`pos-a pos-a-c-m d-fl jc-sb ai-c fl-d-c ${styles.thumbnail_bg} ${
            isGameLockedByBonus ? styles['thumbnail_bg--locked'] : ''
          } ${EComponentVisibility.TableteDesktop}`}
          onClick={
            isGameLockedByBonus
              ? () => {
                  openDesiredPopup();
                }
              : null
          }
        >
          {!isGameLockedByBonus && (
            <>
              {!isLiveGame && (
                <div className={styles.text_wrapper}>
                  <BaseText
                    alignment={EBaseTextPosition.Center}
                    value={props.name}
                    size={EBaseTextSize.Regular}
                    weight={EBaseTextWeight.W400}
                  />
                </div>
              )}
              {auth?.success ? (
                <div className={`${styles.play_circle} pos-a pos-a-c-m d-fl jc-c ai-c`} onClick={handleClick}>
                  <BaseIcon
                    iconName={info?.isMonetaryActivityEnabled ? IconLibrary.Play : IconLibrary.Lock}
                    variant={IconVariantsLibrary.Plain}
                    isMasked={true}
                    isStatic={false}
                  />
                </div>
              ) : (
                showLoginButton ?
                  <div onClick={openSignInPopup} className={`${styles.play_circle} pos-a pos-a-c-m d-fl jc-c ai-c`}>
                    <BaseIcon
                      iconName={IconLibrary.Play}
                      variant={IconVariantsLibrary.Plain}
                      isMasked={true}
                      isStatic={false}
                    />
                  </div> 
                : null
              )}
              {hasDemo && (
                <div className={styles.text_wrapper}>
                  <Link
                    href={demoUrl}
                    style={{
                      color: '#FFFFFF',
                    }}
                  >
                    <BaseText
                      alignment={EBaseTextPosition.Center}
                      value={t('thumbnail.demo.title')}
                      size={EBaseTextSize.Regular}
                      weight={EBaseTextWeight.W400}
                    />
                  </Link>
                </div>
              )}
            </>
          )}
        </div>
        <div
          className={`pos-a pos-a-c-m d-fl jc-sb ai-c fl-d-c ${styles.thumbnail_bg} ${EComponentVisibility.MobileOnly}`}
          onClick={openDesiredPopup}
        ></div>
      </div>
    </>
  );
};

export default ThumbnailElement;
